import { getFileUrl } from '@libs/rest-client';
import { useEffect, useState } from 'react';

interface AttachmentUrlState {
  readonly url: string | null;
  readonly hasFailed: boolean;
}

/** 送信済み添付の表示用 URL。短期の presigned URL なので mount ごとに取得し、どこにも保持しない。 */
export function useAttachmentUrl(storageKey: string): AttachmentUrlState {
  const [state, setState] = useState<AttachmentUrlState>({ url: null, hasFailed: false });

  useEffect(() => {
    let isActive = true;
    setState({ url: null, hasFailed: false });

    getFileUrl(storageKey)
      .then(({ url }) => {
        if (isActive) {
          setState({ url: url || null, hasFailed: !url });
        }
      })
      .catch(() => {
        if (isActive) {
          setState({ url: null, hasFailed: true });
        }
      });

    return () => {
      isActive = false;
    };
  }, [storageKey]);

  return state;
}
